/**
 * Page Header Slider
 * Initializes Swiper on [data-page-header-slider] sections.
 * Handles video play/pause on slide change.
 */

(function () {
  function initPageHeaderSliders() {
    const sections = document.querySelectorAll('[data-page-header-slider]');
    sections.forEach(function (section) {
      if (section.dataset.pageHeaderInitialized === 'true') return;
      const swiperEl = section.querySelector('.page-header-slider_swiper');
      if (!swiperEl) return;

      const wrapper = swiperEl.querySelector('.swiper-wrapper');
      const slides = wrapper ? wrapper.querySelectorAll('.swiper-slide') : [];

      function playVideosInSlide(slide) {
        if (!slide) return;
        const videos = slide.querySelectorAll('video');
        videos.forEach(function (v) {
          v.play().catch(function () {});
        });
      }

      function pauseVideosInSlide(slide) {
        if (!slide) return;
        const videos = slide.querySelectorAll('video');
        videos.forEach(function (v) {
          v.pause();
        });
      }

      function pauseAllVideos() {
        slides.forEach(pauseVideosInSlide);
      }

      if (typeof Swiper === 'undefined') return;

      var swiper = new Swiper(swiperEl, {
        loop: slides.length > 1,
        speed: 600,
        grabCursor: true,
        allowTouchMove: slides.length > 1,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        navigation: slides.length > 1 ? {
          nextEl: section.querySelector('.page-header-slider_nav-btn--next'),
          prevEl: section.querySelector('.page-header-slider_nav-btn--prev')
        } : false,
        on: {
          init: function () {
            var activeSlide = this.slides[this.activeIndex];
            playVideosInSlide(activeSlide);
            updateCustomPagination(this);
          },
          slideChange: function () {
            pauseAllVideos();
            var activeSlide = this.slides[this.activeIndex];
            playVideosInSlide(activeSlide);
            updateCustomPagination(this);
          }
        }
      });

      function updateCustomPagination(swiperInstance) {
        var dots = section.querySelectorAll('.page-header-slider_dot');
        var realIndex = swiperInstance.realIndex;
        dots.forEach(function (dot, i) {
          var isActive = i === realIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      if (slides.length > 1) {
        section.querySelectorAll('.page-header-slider_dot').forEach(function (dot, i) {
          dot.addEventListener('click', function () {
            swiper.slideToLoop(i);
          });
        });
      }

      section._pageHeaderSwiper = swiper;
      section.dataset.pageHeaderInitialized = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPageHeaderSliders);
  } else {
    initPageHeaderSliders();
  }

  document.addEventListener('shopify:section:load', initPageHeaderSliders);
})();
